module.exports = __webpack_public_path__ + "img/1475183795.db130bf5.jpg";